module.exports = __webpack_public_path__ + "img/statement.920d651d.png";